import PropTypes from "prop-types"
import { FastForward, PlayArrow } from "@mui/icons-material"
import { TRADE_STATUS } from "helpers/drift"

const { OVERSOLD_PLUS, OVERSOLD, NEUTRAL, OVERBOUGHT, OVERBOUGHT_PLUS } = TRADE_STATUS

export default function StringDrift({ drift }) {
  switch (drift) {
    case OVERSOLD_PLUS:
      return <FastForward className="components_drift-icon oversold-plus" />
    case OVERSOLD:
      return <PlayArrow className="components_drift-icon oversold" />
    case NEUTRAL:
      return <div className="components_drift-icon" />
    case OVERBOUGHT:
      return <PlayArrow className="components_drift-icon overbought" />
    case OVERBOUGHT_PLUS:
      return <FastForward className="components_drift-icon overbought-plus" />
    default:
      return <div className="components_drift-icon" />
  }
}

StringDrift.propTypes = {
  drift: PropTypes.string.isRequired,
}
